import { render, staticRenderFns } from "./DepartmentEditForm.vue?vue&type=template&id=3e927e1a&"
import script from "./DepartmentEditForm.vue?vue&type=script&lang=ts&"
export * from "./DepartmentEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports